import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";
import axios from "axios";

export const studyLabManagementFileServices = {
  //Lab Management
  uploadStudyLabManagementFile,
  updateStudyLabManagementData,
  deleteStudyLabManagementData,
  softDeleteRestoreStudyLabManagement,
  getStudyLabManagementData,
};

// Upload Study Lab Management File
async function uploadStudyLabManagementFile(formData) {
  try {
    const token = JSON.parse(localStorage.getItem("token"));

    const response = await axios.post(
      `${config.API_URL_USER_ONBOARDING}uploadStudyLabManagementFile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = response.data;
    handleResponse(data);
    return data;
  } catch (error) {
    const errorData = error?.response?.data;
    if (errorData) {
      handleResponse(errorData);
      return errorData;
    }
    handleResponse({
      statusCode: 500,
      customMessage: error?.message || "Something went wrong",
      type: "ERROR",
    });
    return {
      statusCode: 500,
      customMessage: error?.message || "Something went wrong",
      type: "ERROR",
    };
  }
}

// Update Study Lab Management File
async function updateStudyLabManagementData(formData) {
  try {
    const token = JSON.parse(localStorage.getItem("token"));

    const response = await axios.put(
      `${config.API_URL_USER_ONBOARDING}updateStudyLabManagementData`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = response.data;
    handleResponse(data);
    return data;
  } catch (error) {
    const errorData = error?.response?.data;
    if (errorData) {
      handleResponse(errorData);
      return errorData;
    }
    handleResponse({
      statusCode: 500,
      customMessage: error?.message || "Something went wrong",
      type: "ERROR",
    });
    return {
      statusCode: 500,
      customMessage: error?.message || "Something went wrong",
      type: "ERROR",
    };
  }
}

// Soft Delete & Restore Study Lab Management
async function softDeleteRestoreStudyLabManagement(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyLabManagement`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Lab Management
async function deleteStudyLabManagementData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyLabManagementData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Lab Management
async function getStudyLabManagementData(status, studyId, mode, searchData, page, length, datasetType) {
  const datasetTypeQuery = datasetType ? `&datasetType=${datasetType}` : "";
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLabManagementData/${status}/${studyId}/${mode}?search=${searchData || ""}&page=${page}&length=${length}${datasetTypeQuery}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLabManagementData/${status}/${studyId}/${mode}?search=${searchData || ""}${datasetTypeQuery}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}